import { defineComponent, computed, reactive } from 'vue';
import { value2label, QUESTION_TYPE, numberToLetter } from '@/utils';
import Image from './Image.vue';
import CustomAudio from './CustomAudio.vue';
var QUESTION_SLIPT_CODE = '${answer}';
// 分割一个填空题有多个空的答案，需保证用户填写的答案中没有这个字符
var ANSWER_SLIPT_CODE = '|;|';
export default defineComponent({
  name: 'QuestionFillBlank',
  components: {
    Image: Image,
    CustomAudio: CustomAudio
  },
  props: {
    question: {
      type: Object,
      default: function () {
        return {};
      }
    },
    answerMode: {
      type: Boolean,
      default: false
    },
    currentPaperAnswer: {
      type: String
    }
  },
  setup: function (props, _a) {
    var emit = _a.emit;
    var answerList = reactive([]);
    if (props.question.userAnswer) {
      answerList = reactive(props.question.userAnswer.split(ANSWER_SLIPT_CODE));
    }
    var questArr = computed(function () {
      var textArr = props.question.content.split(QUESTION_SLIPT_CODE);
      answerList.length = textArr.length - 1;
      return props.question.content.split(QUESTION_SLIPT_CODE);
    });
    var isUserAnswerRight = computed(function () {
      return props.question.questionStatus === 'success';
    });
    var blurChange = function () {
      var newAnswer = answerList.map(function (item) {
        return item.trim();
      }).join(ANSWER_SLIPT_CODE);
      if (props.question.userAnswer !== newAnswer) {
        emit('change', newAnswer, props.question);
      }
    };
    return {
      questArr: questArr,
      answerList: answerList,
      blurChange: blurChange,
      value2label: value2label,
      QUESTION_TYPE: QUESTION_TYPE,
      numberToLetter: numberToLetter,
      isUserAnswerRight: isUserAnswerRight
    };
  }
});